// The only post-sign-in destination a magic link may carry: a QR check-in handoff ticket. Anything else is ignored,
// so a crafted /magic-link?next=... cannot be used as an open redirect.
const CHECKIN_NEXT = /^\/checkin\?h=[A-Za-z0-9._-]+$/;

export function isCheckinNext(value) {
  return typeof value === "string" && CHECKIN_NEXT.test(value);
}

export function checkinHandoffPath(ticket) {
  return `/checkin?h=${ticket}`;
}
